import { render, staticRenderFns } from "./eg_modal_footer.vue?vue&type=template&id=18d18a30&"
import script from "./eg_modal_footer.vue?vue&type=script&lang=js&"
export * from "./eg_modal_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports